import { useSubscription } from '../../hooks/useSubscription';
import { Progress } from '@/components/ui/progress';
import { Card, CardContent } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';
import { ANALYSES_PER_LICENSE } from '../../config/pricing/limits';

export function UsageIndicator() {
  const { subscription } = useSubscription();

  if (!subscription) return null;

  // For enterprise users, show individual usage within their 1000 analysis limit
  const userAnalysisCount = subscription.analysisCount || 0;
  const userLimit = ANALYSES_PER_LICENSE; // 1000 per license
  const userUsagePercentage = Math.min((userAnalysisCount / userLimit) * 100, 100);

  return (
    <Card className="border-slate-200/60">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <BarChart3 className="h-4 w-4 text-slate-600" />
          <h3 className="text-sm font-medium text-slate-900">Analysis Usage</h3>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">Used this month</span>
            <span className="font-semibold text-slate-900">{userAnalysisCount} / {userLimit.toLocaleString()}</span>
          </div>
          <Progress value={userUsagePercentage} className="h-1.5" />
          <p className="text-xs text-slate-500">
            {(userLimit - userAnalysisCount).toLocaleString()} analyses remaining
          </p>
        </div>
      </CardContent>
    </Card>
  );
}